<template>
  <div id="app" class="app" :class="{'mobile-phone': $store.state.mobile}">
    <jm-message :status="$store.state.messageStatus" :type="$store.state.messageType" :password="$store.state.messagePassword" :phone="$store.state.messagePhone" :text="$store.state.messageText" :click="$store.state.messageClick"></jm-message>
    <router-view v-if="loading"/>
    <div class="loading" v-if="$store.state.loading">
      <div class="circle">
        <div class="circle__item start web-bg-color"></div>
        <div class="circle__item end web-bg-color"></div>
      </div>
    </div>
  </div>
</template>

<script>
import JmMessage from './components/JmMessage.vue'
import CountryJson from './assets/country.json'
export default {
  name: 'app',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    version () {
      const t = this
      return t.$store.getters.versionPrefix === 'P' ? t.$t('title') : t.$t('title') + ' ' + t.$store.getters.versionPrefix
    }
  },
  beforeMount () {
  },
  mounted () {
    const t = this
    t.$store.state.areaCodeJson = []
    t.$store.state.client = process.env.VUE_APP_CLIENT
    t.$store.dispatch('getUserAgent')
    t.$store.dispatch('getCookie', 'i18n_locale').then((res) => {
      t.$i18n.locale = res
      Object.keys(CountryJson.country[this.$i18n.locale]).forEach(element => {
        t.$store.state.areaCodeJson.push({
          key: element,
          value: CountryJson.country[t.$i18n.locale][element]
        })
      })
      document.title = t.version
      t.loading = true
    }).catch(() => {
      t.$i18n.locale = 'zh-Hans'
      Object.keys(CountryJson.country[this.$i18n.locale]).forEach(element => {
        t.$store.state.areaCodeJson.push({
          key: element,
          value: CountryJson.country[t.$i18n.locale][element]
        })
      })
      document.title = t.version
      t.loading = true
    })
  },
  destroyed () {
  },
  methods: {
  },
  components: {
    JmMessage
  }
}
</script>

<style>
html,body {
  margin: 0;
  padding: 0;
  font-size: 16px;
  background-color: #F2F3F7;
}
@media screen and (max-width: 1440px) {
  html,body {
    font-size: calc(1440 / 1920 * 16px);
  }
}
img {
  display: block;
  width: 100%;
}
input {
  padding: 0;
  border: none;
  outline: none;
  display: block;
  width: 100%;
  color: #333333;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333333;
  position: relative;
}
.app {
  min-width: 1024px;
}
.mobile-phone {
  font-size: calc(16 / 375 * 100vw);
  min-width: 100%;
  user-select: none;
}
.button {
  user-select: none;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 98;
  background-color: rgba(255, 255, 255, 0.5);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 1024px;
}
.mobile-phone .loading {
  min-width: 100%;
}
@keyframes start
  {
    0% {
      transform: scale(1, 1)
    }
    50% {
      transform: scale(0, 0)
    }
    100% {
      transform: scale(1, 1)
    }
  }
@keyframes end
  {
    0% {
      transform: scale(0, 0)
    }
    50% {
      transform: scale(1, 1)
    }
    100% {
      transform: scale(0, 0)
    }
  }
.circle {
  width: 60px;
  height: 60px;
  position: relative;
}
.circle__item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  opacity: 0.5;
}
.start {
  animation: start 2s infinite;
}
.end {
  animation: end 2s infinite;
}
.web-color {
  color: #588AFF;
}
.web-bg-color {
  background-color: #588AFF;
}
.app-color {
  color: #2CADA0;
}
.app-bg-color {
  background-color: #2CADA0;
}
.mobile-phone__nav {
  height: calc(60 / 375 * 100vw);
  padding: 0 calc(20 / 375 * 100vw);
  font-weight: 500;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #DDDDDD;
}
.mobile-phone__main{
  padding: 0 calc(20 / 375 * 100vw);
}
</style>
